<pbc-filter-preset
  [filter]="rechnungsVorlagen.preset$ | async"
  [filters]="rechnungsVorlagen.presets$ | async"
  [name]="rechnungsVorlagen.search$ | async"
  (select)="rechnungsVorlagen.setFilter($event)"
  (save)="rechnungsVorlagen.writeFilter($event)"
  (delete)="rechnungsVorlagen.deleteFilter($event)"
></pbc-filter-preset>
